export enum SystemMessage {
  UNKNOWN_ERROR = "Something's wrong",
  INPUT_REQUIRED = "Không được để trống",
  INPUT_INVALID_PRICE = "Giá không hợp lệ",
  COPY_SUCCESSFULLY = "Đã sao chép",
  ADD_SUCCESSFULLY = "Tạo thành công",
  UPDATE_SUCCESSFULLY = "Cập nhật thành công",
  DELETE_SUCCESSFULLY = "Xóa thành công",
  CONFIRM_SUCCESSFULLY = "Xác nhận thành công",
  DELETE_BOOK_NOTIFY = "Bạn có chắc chắn muốn xóa sách này?",
  DELETE_CATEGORY_NOTIFY = "Bạn có chắc chắn muốn xóa danh mục này?",
  DELETE_BG_MUSIC_NOTIFY = "Bạn có chắc chắn muốn xóa nhạc nền này?",
  DELETE_BANK_NOTIFY = "Bạn có chắc chắn muốn xóa ngân hàng này?",
  CONFIRM_TRANSACTION_NOTIFY = "Bạn có chắc chắn muốn xác nhận giao dịch này?",
  MAX_SIZE_UPLOAD = "Chọn file nhỏ hơn 512 MB",
  EMAIL_ADDRESS_INVALID = "Địa chỉ email không hợp lệ",
  FULL_NAME_REQUIRED = "Vui lòng nhập họ và tên của bạn.",
  USERNAME_REQUIRED = "Tên đăng nhập không thể để trống!",
  PASSWORD_REQUIRED = "Vui lòng nhập mật khẩu.",
  CONFIRM_PASSWORD_REQUIRED = "Vui lòng nhập lại mật khẩu.",
  CONFIRM_PASSWORD_INVALID = "Mật khẩu nhập lại không khớp.",
  AGREE_TERMS_REQUIRED = "Bạn chưa đồng ý với điều khoản sử dụng.",
  TRANSFER_SUCCESSFULLY = "Chuyển khoản thành công",
  TIMEOUT = "Hết thời gian",
  ACCESS_DENIED = "Không có quyền truy cập",
  LOGIN_FAILED = "Login Failed",
  LINK_STORE_EMPTY = "Chưa có liên kết mua sách",
  SELECT_CATEGORY_REQUIRED = "Bạn hãy lựa chọn ít nhất 1 chủ đề",
  CHANGE_PASSWORD_SUCCESSFULLY = "Thay đổi mật khẩu thành công",
  FOLLOW_AUTHOR_SUCCESSFULLY = "Theo dõi tác giả thành công",
  UNFOLLOW_AUTHOR_SUCCESSFULLY = "Bỏ theo dõi tác giả thành công",
  USERNAME_INVALID = "Tên đăng nhập viết liền không dấu",
  PHONE_INVALID = "Số điện thoại không hợp lệ",
  DELETE_COMMENT_NOTIFY = "Bạn có chắc chắn muốn xóa bình luận này không?",
  CREATE_BOOK_NOTE_SUCESS = "Tạo ghi chú thành công",
  CREATE_BOOK_NOTE_MAX_LENGTH = "Không được vượt quá 100 ký tự"
}
